import { ConfigConstants } from '../config/config-constants';

export interface ConfigInterface {
    getCseCountry(): string;
    getUseCustomisedForms(): boolean;
    getCseEmailFax(): string;
    getParticipantCopySupportByNotificationType(notificationType: ConfigConstants.NotificationTypes): string[];
}

export type ConfigParticipantCopySupportByNotificationType = {
    [key in ConfigConstants.NotificationTypes]?: Array<'832' | '834' | '837' | '336'>;
};
